// // import React, { useState } from 'react';
// // import {
// //   Dialog, DialogTitle, DialogContent, DialogActions,
// //   Box, Typography, TextField, Button, RadioGroup, FormControlLabel,
// //   Radio, Alert, CircularProgress,
// // } from '@mui/material';
// // import { submitCaseWorkerDecision } from './workflowApi';

// // const OPTIONS = [
// //   {
// //     value: 'full_lump_sum',
// //     label: 'Ready to pay the full amount now (single payment)',
// //     hint: 'Routes to Workflow 1 — goes straight to Shirastedar for review.',
// //   },
// //   {
// //     value: 'full_with_installments',
// //     label: 'Will pay the full amount, but needs installments',
// //     hint: 'Routes to Workflow 2 — goes to the Forensic Auditor first.',
// //   },
// //   {
// //     value: 'not_agreed_or_partial',
// //     label: 'Not agreed to pay / records mismatch / proposes a lesser amount',
// //     hint: 'Routes to Workflow 2 — goes to the Forensic Auditor first.',
// //   },
// // ];

// // const CaseWorkerDecisionDialog = ({ open, onClose, excessId, refId, onSuccess, onError }) => {
// //   const [decision, setDecision] = useState('');
// //   const [remarks, setRemarks] = useState('');
// //   const [submitting, setSubmitting] = useState(false);

// //   const reset = () => {
// //     setDecision('');
// //     setRemarks('');
// //   };

// //   const handleClose = () => {
// //     if (submitting) return;
// //     reset();
// //     onClose();
// //   };

// //   const handleSubmit = async () => {
// //     if (!decision) {
// //       onError('Please select how the accused wants to proceed.');
// //       return;
// //     }
// //     try {
// //       setSubmitting(true);
// //       await submitCaseWorkerDecision(excessId, { decision, remarks });
// //       onSuccess('Case submitted — routed to the correct workflow.');
// //       reset();
// //       onClose();
// //     } catch (err) {
// //       onError(err?.response?.data?.error || 'Failed to submit decision.');
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   return (
// //     <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
// //       <DialogTitle>
// //         Submit Case — {refId}
// //       </DialogTitle>
// //       <DialogContent>
// //         <Typography variant="body2" color="text.secondary" mb={2}>
// //           Choose the option that matches what the accused has told you. This decides
// //           which workflow the case follows next.
// //         </Typography>

// //         <RadioGroup value={decision} onChange={(e) => setDecision(e.target.value)}>
// //           {OPTIONS.map((opt) => (
// //             <Box
// //               key={opt.value}
// //               sx={{
// //                 border: '1px solid',
// //                 borderColor: decision === opt.value ? 'primary.main' : 'divider',
// //                 borderRadius: 2,
// //                 p: 1.5,
// //                 mb: 1.5,
// //                 bgcolor: decision === opt.value ? 'primary.50' : 'transparent',
// //                 transition: 'all 0.15s',
// //               }}
// //             >
// //               <FormControlLabel
// //                 value={opt.value}
// //                 control={<Radio />}
// //                 label={<Typography fontWeight={600}>{opt.label}</Typography>}
// //               />
// //               <Typography variant="caption" color="text.secondary" sx={{ pl: 4 }}>
// //                 {opt.hint}
// //               </Typography>
// //             </Box>
// //           ))}
// //         </RadioGroup>

// //         <TextField
// //           label="Remarks"
// //           fullWidth
// //           multiline
// //           rows={2}
// //           value={remarks}
// //           onChange={(e) => setRemarks(e.target.value)}
// //           sx={{ mt: 1 }}
// //           placeholder="Any notes for the next reviewer..."
// //         />

// //         {decision && decision !== 'full_lump_sum' && (
// //           <Alert severity="info" sx={{ mt: 2 }}>
// //             This case will go to the Forensic Auditor before it reaches Shirastedar.
// //           </Alert>
// //         )}
// //       </DialogContent>
// //       <DialogActions>
// //         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
// //         <Button
// //           onClick={handleSubmit}
// //           variant="contained"
// //           disabled={submitting || !decision}
// //           startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
// //         >
// //           {submitting ? 'Submitting...' : 'Submit Case'}
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default CaseWorkerDecisionDialog;


// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Box, Typography, TextField, Button, Alert, CircularProgress,
//   List, ListItem, ListItemIcon, ListItemText, Chip, Divider,
// } from '@mui/material';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
// import EditIcon from '@mui/icons-material/Edit';
// import { fetchCaseWorkerReadiness, submitCaseWorkerDecision, WORKFLOW_LABELS } from './workflowApi';
// import DocsEditModal from './staffDocsEpmsModal';

// // Docs + Order Status + Payment/installment must all be complete first — the
// // workflow is then computed automatically (no manual radio choice). This
// // dialog just shows readiness + a preview, and lets the Case Worker jump
// // straight into editing whatever's still missing.
// const CaseWorkerDecisionDialog = ({ open, onClose, excessId, refId, excessAmt, onSuccess, onError }) => {
//   const [loadingReadiness, setLoadingReadiness] = useState(false);
//   const [readiness, setReadiness] = useState(null);
//   const [remarks, setRemarks] = useState('');
//   const [submitting, setSubmitting] = useState(false);
//   const [editModalOpen, setEditModalOpen] = useState(false);

//   const loadReadiness = useCallback(() => {
//     if (!excessId) return;
//     setLoadingReadiness(true);
//     fetchCaseWorkerReadiness(excessId)
//       .then((res) => setReadiness(res.data))
//       .catch((err) => onError(err?.response?.data?.error || 'Failed to load readiness check.'))
//       .finally(() => setLoadingReadiness(false));
//   }, [excessId, onError]);

//   useEffect(() => {
//     if (open) loadReadiness();
//   }, [open, loadReadiness]);

//   const handleClose = () => {
//     if (submitting) return;
//     setRemarks('');
//     setReadiness(null);
//     onClose();
//   };

//   const handleEditModalClose = () => {
//     setEditModalOpen(false);
//     loadReadiness(); // refresh readiness after any edits
//   };

//   const handleSubmit = async () => {
//     try {
//       setSubmitting(true);
//       await submitCaseWorkerDecision(excessId, { remarks });
//       onSuccess('Case submitted — routed automatically to the correct workflow.');
//       setRemarks('');
//       setReadiness(null);
//       onClose();
//     } catch (err) {
//       onError(err?.response?.data?.error || 'Failed to submit case.');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const isReady = readiness?.ready;

//   return (
//     <>
//       <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//         <DialogTitle>Submit Case — {refId}</DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" mb={2}>
//             Documents, Order Status, and the payment agreement (including
//             number of installments) must all be complete before this case
//             can move forward. The workflow it follows next is decided
//             automatically from that data.
//           </Typography>

//           <Button
//             variant="outlined"
//             startIcon={<EditIcon />}
//             fullWidth
//             onClick={() => setEditModalOpen(true)}
//             sx={{ mb: 2 }}
//           >
//             Edit Documents / Order Status / Payment
//           </Button>

//           {loadingReadiness ? (
//             <Box display="flex" justifyContent="center" py={3}>
//               <CircularProgress size={24} />
//             </Box>
//           ) : readiness ? (
//             <>
//               <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                 Checklist
//               </Typography>
//               {isReady ? (
//                 <Alert severity="success" sx={{ mb: 2 }}>
//                   Everything required is complete.
//                 </Alert>
//               ) : (
//                 <List dense sx={{ mb: 1 }}>
//                   {readiness.missing.map((item, idx) => (
//                     <ListItem key={idx} disableGutters sx={{ py: 0.25 }}>
//                       <ListItemIcon sx={{ minWidth: 32 }}>
//                         <RadioButtonUncheckedIcon fontSize="small" color="warning" />
//                       </ListItemIcon>
//                       <ListItemText primary={item} />
//                     </ListItem>
//                   ))}
//                 </List>
//               )}

//               {isReady && readiness.workflow_preview && (
//                 <Box sx={{ mt: 1, mb: 2 }}>
//                   <Divider sx={{ mb: 1.5 }} />
//                   <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                     Preview — where this will route
//                   </Typography>
//                   <Chip
//                     icon={<CheckCircleIcon />}
//                     label={WORKFLOW_LABELS[readiness.workflow_preview] || readiness.workflow_preview}
//                     color={readiness.workflow_preview === 'workflow_1' ? 'success' : 'secondary'}
//                     sx={{ fontWeight: 600 }}
//                   />
//                 </Box>
//               )}
//             </>
//           ) : null}

//           <TextField
//             label="Remarks"
//             fullWidth
//             multiline
//             rows={2}
//             value={remarks}
//             onChange={(e) => setRemarks(e.target.value)}
//             placeholder="Any notes for the next reviewer..."
//             sx={{ mt: 1 }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
//           <Button
//             onClick={handleSubmit}
//             variant="contained"
//             disabled={submitting || !isReady}
//             startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
//           >
//             {submitting ? 'Submitting...' : 'Submit Case'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <DocsEditModal
//         open={editModalOpen}
//         onClose={handleEditModalClose}
//         excessId={excessId}
//         refId={refId}
//         excessAmt={excessAmt}
//       />
//     </>
//   );
// };

// export default CaseWorkerDecisionDialog;

import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, TextField, Button, Alert, CircularProgress,
  List, ListItem, ListItemIcon, ListItemText, Chip, Divider,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import EditIcon from '@mui/icons-material/Edit';
import { fetchCaseWorkerReadiness, submitCaseWorkerDecision, WORKFLOW_LABELS } from './workflowApi';
import DocsEditModal from './staffDocsEpmsModal';

// Docs + Order Status + Payment/installment must all be complete first — the
// workflow is then computed automatically (no manual radio choice). This
// dialog just shows readiness + a preview, and lets the Case Worker jump
// straight into editing whatever's still missing.
const CaseWorkerDecisionDialog = ({ open, onClose, excessId, refId, excessAmt, onSuccess, onError }) => {
  const [loadingReadiness, setLoadingReadiness] = useState(false);
  const [readiness, setReadiness] = useState(null);
  const [remarks, setRemarks] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const loadReadiness = useCallback(() => {
    if (!excessId) return;
    setLoadingReadiness(true);
    fetchCaseWorkerReadiness(excessId)
      .then((res) => setReadiness(res.data))
      .catch((err) => onError(err?.response?.data?.error || 'Failed to load readiness check.'))
      .finally(() => setLoadingReadiness(false));
  }, [excessId, onError]);

  useEffect(() => {
    if (open) loadReadiness();
  }, [open, loadReadiness]);

  const handleClose = () => {
    if (submitting) return;
    setRemarks('');
    setReadiness(null);
    onClose();
  };

  const handleEditModalClose = () => {
    setEditModalOpen(false);
    loadReadiness(); // refresh readiness after any edits
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      await submitCaseWorkerDecision(excessId, { remarks });
      onSuccess('Case submitted — routed automatically to the correct workflow.');
      setRemarks('');
      setReadiness(null);
      onClose();
    } catch (err) {
      onError(err?.response?.data?.error || 'Failed to submit case.');
    } finally {
      setSubmitting(false);
    }
  };

  const isReady = readiness?.ready;

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Submit Case — {refId}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Documents, Order Status, and the payment agreement (including
            number of installments) must all be complete before this case
            can move forward. The workflow it follows next is decided
            automatically from that data.
          </Typography>

          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            fullWidth
            onClick={() => setEditModalOpen(true)}
            sx={{ mb: 2 }}
          >
            Edit Documents / Order Status / Payment
          </Button>

          {loadingReadiness ? (
            <Box display="flex" justifyContent="center" py={3}>
              <CircularProgress size={24} />
            </Box>
          ) : readiness ? (
            <>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                Checklist
              </Typography>
              {isReady ? (
                <Alert severity="success" sx={{ mb: 2 }}>
                  Everything required is complete.
                </Alert>
              ) : (
                <List dense sx={{ mb: 1 }}>
                  {readiness.missing.map((item, idx) => (
                    <ListItem key={idx} disableGutters sx={{ py: 0.25 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <RadioButtonUncheckedIcon fontSize="small" color="warning" />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              )}

              {isReady && readiness.workflow_preview && (
                <Box sx={{ mt: 1, mb: 2 }}>
                  <Divider sx={{ mb: 1.5 }} />
                  <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                    Preview — where this will route
                  </Typography>
                  <Chip
                    icon={<CheckCircleIcon />}
                    label={WORKFLOW_LABELS[readiness.workflow_preview] || readiness.workflow_preview}
                    color={readiness.workflow_preview === 'workflow_1' ? 'success' : 'secondary'}
                    sx={{ fontWeight: 600 }}
                  />
                </Box>
              )}
            </>
          ) : null}

          <TextField
            label="Remarks"
            fullWidth
            multiline
            rows={2}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Any notes for the next reviewer..."
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={submitting || !isReady}
            startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {submitting ? 'Submitting...' : 'Submit Case'}
          </Button>
        </DialogActions>
      </Dialog>

      <DocsEditModal
        open={editModalOpen}
        onClose={handleEditModalClose}
        excessId={excessId}
        refId={refId}
        excessAmt={excessAmt}
      />
    </>
  );
};

export default CaseWorkerDecisionDialog;